export default {"src":"/_next/static/media/visa-light-noborder.800c92eb.svg","height":24,"width":36};